<template>
  <div :class="$utils.isMobile() ? 'cpt-process-m' : 'cpt-process'">
    <img class="back-img" src="../assets/service-bg1.png" alt="">
    <div class="content">
      <div class="title-en tit-en" v-if="$i18n.locale == 'zh-CN'">{{ processData.titleEn }}</div>
      <div class="title tit">{{ processData.title }}</div>
      <cpt-divider :type="1"></cpt-divider>
      <div class="list">
        <div class="item" v-for="item in processData.list" :key="item.id">
          <div class="item-box">
            <img class="icon" :src="item.icon" alt="">
            <div :class="$i18n.locale == 'en-US' ? 'name-en' : 'name'">{{ item.name }}</div>
          </div>
          <img
            class="next"
            src="../assets/service-icon5.png"
            alt=""
            v-if="item.id != processData.list.length"
          >
        </div>
      </div>
      <div class="text">{{ processData.text }}</div>
    </div>
  </div>
</template>

<script>
import cptDivider from './cpt-divider.vue';
export default {
  name: 'cpt-process',
  components: {
    cptDivider
  },
  data() {
    return {
      processData: this._contentData.processData
    }
  },

  methods: {

  },
}

</script>

<style lang='scss' scoped>
.cpt-process {
  width: auto;
  position: relative;
  display: flex;
  .back-img{
    width: 100%;
  }
  .content{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .tit-en{
      color: rgba(255, 255, 255, 0.3);
      // text-align: center;
    }
    .tit{
      color: rgba(255, 255, 255, 1);
      // text-align: center;
    }
    .list{
      width: 1200px;
      margin: 50px 0;
      display: flex;
      justify-content: center;
      .item{
        // width: 25%;
        display: flex;
        align-items: center;
        .item-box{
          border: 1px solid #fff;
          width: 230px;
          height: 290px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 0px 30px;
          box-sizing: border-box;
          .icon{
            height: 150px;
          }
          .name{
            color: #fff;
            font-size: 22px;
            // font-family: MiSans-Demibold;
            // margin-top: 30px;
            text-align: center;
          }
          .name-en{
            color: #fff;
            font-size: 14px;
            // font-family: MiSans-Demibold;
            // margin-top: 30px;
            text-align: center;
          }
        }
        .next{
          height: 40px;
          padding: 0 30px;
        }
      }
    }
    .text{
      font-size: 26px;
      color: #fff;
      // font-family: MiSans-Regular;
    }
  }
}
.cpt-process-m {
  // width: 100%;
  position: relative;
  display: flex;
  text-align: center;
  .cpt-divider-m{
    margin: 10px 0;
  }
  .back-img{
    height: 300px;
    object-position: 70% 0;
    overflow: hidden;
  }
  .content{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .tit-en{
      color: rgba(255, 255, 255, 0.3);
      // text-align: center;
    }
    .tit{
      color: rgba(255, 255, 255, 1);
      // text-align: center;
    }
    .list{
      // width: 1200px;
      margin: 15px 0;
      display: flex;
      justify-content: center;
      .item{
        // width: 25%;
        display: flex;
        align-items: center;
        .item-box{
          border: 1px solid #fff;
          width: 70px;
          height: 90px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 0px 8px;
          box-sizing: border-box;
          .icon{
            width: 50px;
          }
          .name{
            color: #fff;
            font-size: 8px;
            // font-family: MiSans-Demibold;
            text-align: center;
          }
          .name-en{
            color: #fff;
            font-size: 5px;
            // font-family: MiSans-Demibold;
            text-align: center;
            letter-spacing: normal;
          }
        }
        .next{
          height: 20px;
          padding: 0 5px;
        }
      }
    }
    .text{
      width: 70%;
      font-size: 10px;
      color: #fff;
      // font-family: MiSans-Regular;
    }
  }
}
</style>